// extracted by mini-css-extract-plugin
export var wordContainer = "_rb-0";